module.exports = __webpack_public_path__ + "static/media/良好.30ba5597.svg";